import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Box,
} from "@mui/material";
import { useState } from "react";
import { getChoiceItems } from "../apis/RangerOnlineApi";
import { ProductItemSm } from "../components/ProductItemSm";
import { UpSellItem } from "../components/UpSellItem";

export const UpSellItemDialog = (props) => {
  const {
    open,
    onClose,
    categoryDescription,
    products,
    onProductClick,
    onDialogClose,
  } = props;

  const handleDialogClose = async (productId) => {
    onProductClick(productId, true);
    onDialogClose();
  };

  return (
    <Dialog open={open} fullWidth={true}>
      <DialogTitle>{categoryDescription}</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            overflowY: "scroll",
          }}
        >
          <Grid container spacing={1}>
            {products.map((product) => {
              return (
                <UpSellItem
                  key={product.productName + product.productId}
                  id={product.id}
                  name={product.productName}
                  description={product.productDescription}
                  price={0}
                  imageUrl={product.imageUrl}
                  onOpen={async () => handleDialogClose(product.productId)}
                />
              );
            })}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "flex-start" }}>
        <Button variant="contained" color="error" autoFocus onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
